import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Home from "./components/Home";
import Login from "./components/Login";
import ShoppingPage from "./components/shoppingPage";
import CartPage from "./components/CartPage";
import AdminPanel from "./components/AdminPanel";
import AccountPage from "./components/AccountPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider> {/* ✅ CartProvider should wrap the entire app */}
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/shop" element={<ShoppingPage />} />
            <Route path="/cart" element={<CartPage />} /> {/* ✅ Fixed Route for Cart */}
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/account" element={<AccountPage />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
